import { z } from 'zod';
import { dateTimeUtcStringSchema } from '@mews/framework';
import { ageCategoriesCounterFieldsSchema } from '../../../../components/form/hookFields/AgeCategoriesCounterField';

export enum NewReservationFormKeys {
    ArrivalDate = 'arrivalDate',
    DepartureDate = 'departureDate',
    ArrivalHours = 'arrivalHours',
    DepartureHours = 'departureHours',
    AgeCategories = 'ageCategories',
    Rate = 'rate',
}

export const newReservationFormSchema = z.object({
    [NewReservationFormKeys.ArrivalDate]: dateTimeUtcStringSchema,
    [NewReservationFormKeys.DepartureDate]: dateTimeUtcStringSchema,
    [NewReservationFormKeys.ArrivalHours]: z.string(),
    [NewReservationFormKeys.DepartureHours]: z.string(),
    [NewReservationFormKeys.AgeCategories]: ageCategoriesCounterFieldsSchema,
    [NewReservationFormKeys.Rate]: z.string().optional().nullable(),
});

export type NewReservationFormValues = z.infer<typeof newReservationFormSchema>;
